import {
  Component,
  h,
  Host, State, Element
} from '@stencil/core';

@Component({
  tag: 'envc-hero-teaser-liste',
  styleUrl: 'hero-teaser-liste.scss',
  scoped: true
})
export class HeroTeaserListe {
  @Element() el: HTMLElement;
  @State() image: string;

  componentDidLoad() {
    const updateImage = () => {
      const imgElement = this.el.querySelector('img[slot="image"]') as HTMLImageElement;
      if (imgElement && imgElement.src) {
        this.image = imgElement.src;
      }
    };

    // Initial check
    updateImage();

    // Optional: watch for dynamic changes
    const observer = new MutationObserver(updateImage);
    observer.observe(this.el, { childList: true, subtree: true });
  }

  render() {
    return (
      <Host>
        <section>
          <div class="image-wrapper" style={{ backgroundImage: this.image ? `url(${this.image})` : 'none' }}>
            <slot name="image"></slot>
          </div>

          <div class="list-wrapper">
            <div class="container">
              <slot name="list"></slot>
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
